<template>
    <Teams></Teams>
</template>

<script>
import { defineAsyncComponent } from "vue";

const AuthLayout = defineAsyncComponent(() =>
    import("../../../Layouts/AuthLayout.vue")
);
const Teams = defineAsyncComponent(() =>
    import("../../../components/ITDepartment/RemoteWorking/Teams.vue")
);

export default {
    name: "Teams_Collaboration", //The name you are in should not equal the name of the component you are importing.
    components: { Teams, AuthLayout },
};
</script>
